import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useState, type FormEvent } from 'react';
import { Button, Field } from '@voice/ui';
import { Wordmark } from '../components/Wordmark';
import { api } from '../lib/api';
import { ME_KEY } from '../lib/auth';
import styles from './Login.module.css';

export function Login() {
  const queryClient = useQueryClient();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const login = useMutation({
    mutationFn: () => api('/auth/login', { method: 'POST', body: { email, password } }),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ME_KEY }),
  });

  const submit = (e: FormEvent) => {
    e.preventDefault();
    login.mutate();
  };

  return (
    <main className={styles.page}>
      <form className={styles.form} onSubmit={submit} noValidate>
        <Wordmark />
        <h1 className={styles.title}>Anmelden</h1>
        <Field label="E-Mail" type="email" autoComplete="username" value={email} onChange={(e) => setEmail(e.target.value)} required autoFocus />
        <Field label="Passwort" type="password" autoComplete="current-password" value={password} onChange={(e) => setPassword(e.target.value)} required />
        {login.isError && (
          <p role="alert" className={styles.error}>
            {login.error.message}
          </p>
        )}
        <Button type="submit" disabled={login.isPending || !email || !password}>
          {login.isPending ? 'Anmelden …' : 'Anmelden'}
        </Button>
      </form>
    </main>
  );
}
